import { withObjectionFaqs } from "@/lib/faqs";
import { createFileRoute } from "@tanstack/react-router";
import { ServicePageLayout } from "@/components/ServicePageLayout";
import { SERVICE_PAGES } from "@/lib/service-content";
import { buildService, buildFaqPage, buildBreadcrumbs, buildLocalBusiness } from "@/components/SchemaJsonLd";

const data = SERVICE_PAGES["metallic-epoxy-flooring"];

export const Route = createFileRoute("/services/metallic-epoxy-flooring")({
  head: () => ({
    meta: [
      { title: "Metallic Epoxy Flooring in the Calgary region | MLC Epoxy Floors" },
      { name: "description", content: "Premium metallic epoxy floor coatings with 3D pearlescent depth. Designer showroom finishes serving the entire Calgary Region. Free quotes." },
      { property: "og:title", content: "Metallic Epoxy Flooring | MLC Epoxy Floors" },
      { property: "og:description", content: "One-of-a-kind metallic epoxy floor coatings with copper, bronze, pewter, and pearl finishes." },
      { property: "og:url", content: "/services/metallic-epoxy-flooring" },
    ],
    links: [{ rel: "canonical", href: "/services/metallic-epoxy-flooring" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(buildLocalBusiness()) },
      { type: "application/ld+json", children: JSON.stringify(buildService(data.name, data.slug, data.intro)) },
      { type: "application/ld+json", children: JSON.stringify(buildFaqPage(withObjectionFaqs(data.faqs))) },
      { type: "application/ld+json", children: JSON.stringify(buildBreadcrumbs([
        { name: "Home", href: "/" }, { name: "Services", href: "/services" }, { name: data.name, href: `/services/${data.slug}` }
      ])) },
    ],
  }),
  component: () => <ServicePageLayout {...data} />,
});
